<template>
  <!-- my code -->
  <div class="wrapper-main-content">
    <!-- sidebar -->
      <div class="sidebar">
          <side-bar :step="step" :sidebarListLinks="sidebarListLinks"></side-bar>
        </div>
    <!-- sidebar ends -->

    <!-- form -->
    <div class="main_content-form">
        <div class="contractor-form-box p-4">
          <div class="card-body">
            <h1 class="head-title font-weight-bold text-center">Strata Plan - Address</h1>

            <b-form @submit.prevent="componentFormSubmitted" class="mt-5">
              <b-form-group label="Building" v-slot="{ ariaDescribedby }">
                <b-form-input
                  placeholder=""
                  type="text"
                  v-model="componentForm.building"
                  :aria-describedby="ariaDescribedby"
                  v-bind:class="{
                    'is-invalid': form.errors.has('building'),
                  }"
                ></b-form-input>
                <has-error :form="form" field="building"></has-error>
              </b-form-group>

              <b-form-group>
                <template v-slot:label>
                  Street <span class="text-danger">*</span>
                </template>
                <b-form-input
                  placeholder=""
                  type="text"
                  v-model="componentForm.street"
                  :aria-describedby="ariaDescribedby"
                  v-bind:class="{
                    'is-invalid': form.errors.has('street'),
                  }"
                ></b-form-input>
                <has-error :form="form" field="street"></has-error>
              </b-form-group>

              <b-form-group>
                  <template v-slot:label>
                  Suburb <span class="text-danger">*</span>
                </template>
                <b-form-input
                  placeholder=""
                  type="text"
                  v-model="componentForm.suburb"
                  :aria-describedby="ariaDescribedby"
                  v-bind:class="{
                    'is-invalid': form.errors.has('suburb'),
                  }"
                ></b-form-input>
                <has-error :form="form" field="suburb"></has-error>
              </b-form-group>

              <b-form-group>
                  <template v-slot:label>
                  State <span class="text-danger">*</span>
                </template>

                   <b-form-select
                  v-model="componentForm.state"
                  :aria-describedby="ariaDescribedby"
                  :options="stateOptions"
                  v-bind:class="{
                    'is-invalid': form.errors.has('state'),
                  }"

                ></b-form-select>
                <has-error :form="form" field="state"></has-error>
              </b-form-group>

              <b-form-group>
                  <template v-slot:label>
                  Post Code <span class="text-danger">*</span>
                </template>
                <b-form-input
                  placeholder=""
                  type="text"
                  v-model="componentForm.postcode"
                  :aria-describedby="ariaDescribedby"
                  v-bind:class="{
                    'is-invalid': form.errors.has('postcode'),
                  }"
                ></b-form-input>
                <has-error :form="form" field="postcode"></has-error>
              </b-form-group>

              <b-form-group>
                  <template v-slot:label>
                  Registered Lot(s) <span class="text-danger">*</span>
                </template>
                <b-form-input
                  type="text"
                  v-model="componentForm.registered_lots"
                  :aria-describedby="ariaDescribedby"
                  v-bind:class="{
                    'is-invalid': form.errors.has('registered_lots'),
                  }"
                ></b-form-input>
                <has-error :form="form" field="registered_lots"></has-error>
              </b-form-group>

             <b-form-group class="position-relative">
               <div class="input">
                <b-form-file
                  placeholder="Upload photo(s)"
                  multiple
                  :file-name-formatter="formatFilePickerNames"
                  @change="attachementsChanged($event,'photo')"
                >
                </b-form-file>
                <label class="upload-tab mb-0">
                      <SvgIcons icon="upload-document-button" width="25px" height="20px" svgClass="upload-docs" />
                      <span class="upload-instruction">Allowed file types .jpg, .png. Max file size 5 MB.</span>
                  </label>
               </div>
              </b-form-group>

                <b-row class="mb-2">
                  <div class="up-box d-flex mr-2 ml-2"  v-for="(file, idx2) in componentForm.site_photos" :key="'qp-file'+'-'+idx2">
                    <p>{{file.name}}</p>
                    <SvgIcons icon="insurance-document-close" svgClass="ml-2" style="margin-top:2px;"  @click.native="removeMedia(file, 'photo')"/>
                    <span class="upload-instruction">Allowed file types .pdf, .doc, .jpg, .png. Max file size 5 MB. </span>
                  </div>
                </b-row>



            <b-form-group class="position-relative">
              <b-form-file
                    placeholder="Upload Documents"
                    multiple
                    :file-name-formatter="formatFilePickerNames"
                    @change="attachementsChanged($event,'document')"
                ></b-form-file>

                <label class="upload-tab">
                    <SvgIcons icon="upload-document-button" width="25px" height="20px" svgClass="upload-docs" />
                    <span class="upload-instruction">Allowed file types .pdf, .doc. Max file size 5 MB.</span>
                </label>


              </b-form-group>


              <b-row class="mb-2">
                <div class="up-box d-flex mr-2 ml-2"  v-for="(file, idx2) in componentForm.attachements" :key="'qd-file'+'-'+idx2">
                    <p>{{file.name}}</p>
                    <SvgIcons icon="insurance-document-close" svgClass="ml-2" style="margin-top:2px;"  @click.native="removeMedia(file, 'document')"/>
                </div>
              </b-row>

              <div class="btn-actions">
                <b-button
                  class="back-btn"
                  :disabled="form.busy"
                  type="button"
                  variant="primary"
                  @click="$router.go(-1)"
                  >Back
                  </b-button>

                <b-button
                  class="btn-grad btn-next"
                  :disabled="form.busy"
                  type="submit"
                  variant="primary"
                  >Next
                </b-button>
              </div>

            </b-form>
          </div>
        </div>
    </div>
    <!-- form ends -->
  </div>
  <!-- my code ends -->

</template>

<script>
import NavBar from "../../includes/NavBar.vue";
import SideBar from "../../includes/SideBar.vue";
import FooterComponent from "../../../includes/FooterComponent.vue";
import { HasError } from "vform";
import _ from "lodash";
import SvgIcons from "@frontendPages/includes/SvgIconsComponent.vue";

export default {
  props: ["form", "step", 'sidebarListLinks', "eventParentToChildComponentFrom"],
  components: {
    SideBar,
    FooterComponent,
    NavBar,
    HasError,
    SvgIcons,
  },
  data() {
    return {
      componentForm: {
        building: "",
        street: "",
        suburb: "",
        state: "",
        postcode: "",
        registered_lots: "",
        attachements: [],
        site_photos: [],
      },
      stateOptions:
      [
        { value: 'NSW', text: 'NSW' },
        { value: 'ACT', text: 'ACT' },
        { value: 'VIC', text: 'VIC' },
        { value: 'QLD', text: 'QLD' },
        { value: 'WA', text: 'WA' },
        { value: 'SA', text: 'SA' },
        { value: 'NT', text: 'NT' },
        { value: 'TAS', text: 'TAS' },
        ]
    };
  },
  mounted() {
    _.forEach(this.form, (value, field) => {
      if (field in this.componentForm) {
        this.componentForm[field] = value;
      }
    });

    //Called by parent from index page
    this.eventParentToChildComponentFrom.$on('event-parent-child-componentform', this.eventFromParentToChildComponentForm)
  },
  methods: {
    componentFormSubmitted() {
      this.$emit("componentFormSubmitted", this.componentForm, 2);
    },
    formatFilePickerNames(files) {
      return files.length === 1
        ? files[0].name
        : `${files.length} files selected`;
    },
    attachementsChanged(event, file_type){

      this.$root.$data.bsLoader = true;
      if(!event.target.files.length) return;
      var input = event.target.files;
      input && _.forEach(input, file => {

        const formData = new FormData();                //For uploading in storage
        formData.append("upload", file);
        formData.append("strata_plan_id", this.$route.params.id);
        formData.append("file_type", file_type);

        axios.post("api/manager/strata-plan/addMediaToStrataPlan", formData, { headers: { "Content-Type": "multipart/form-data" }})
          .then(response => {
              let extension = file.name.split('.').pop();
              if (file_type == 'document') {
                  this.componentForm.attachements.push({
                      extension: extension,
                      name: file.name,
                      uuid: response.data.uuid
                  });
              }
              if (file_type == 'photo') {
                  this.componentForm.site_photos.push({
                      extension: extension,
                      name: file.name,
                      uuid: response.data.uuid
                  });
              }
              this.$root.$data.bsLoader = false;
          }).catch((err) => {
              this.$root.$data.bsLoader = false;
       });
      });
      event.target.value = '';
    },
        editFileName(file){
               axios.post('api/manager/strata-plan/editFileName', {
                   file : file
                   }).then(response => {
                });
        },
    removeMedia(file, file_type){
      this.$root.$data.bsLoader = true;
      if(file.uuid){
        axios.post('api/manager/strata-plan/deleteMedia', { file }).then(response => {
          if(file_type == 'photo'){
               this.componentForm.site_photos.splice(this.componentForm.site_photos.indexOf(file), 1);
          }else if(file_type == 'document'){
              this.componentForm.attachements.splice(this.componentForm.attachements.indexOf(file), 1);
          }this.$root.$data.bsLoader = false;

            }).catch((err) => {
              this.$root.$data.bsLoader = false;
        });
      }else{
          if(file_type == 'photo'){
               this.componentForm.site_photos.splice(this.componentForm.site_photos.indexOf(file), 1);
          }else if(file_type == 'document'){
              this.componentForm.attachements.splice(this.componentForm.attachements.indexOf(file), 1);
          }

      }

    },
    eventFromParentToChildComponentForm(value){
      _.forEach(value.data, (value, field) => {
          if (field in this.componentForm) {
              this.componentForm[field] = value;
          }
      });
    },
  },
};
</script>

